'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import debounce from 'react-utils/debounce';
import FormattedMessage from 'I18n/components/FormattedMessage';
import classnames from 'classnames';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { MAX_SEARCH_QUERY_LENGTH, SEARCH_QUERY_WARN_LENGTH } from 'FileManagerCore/constants/CrmPlatformLimits';
import { getHasSeenAdvancedSearchDashboardPopup } from 'FileManagerCore/selectors/UserSettings';
import AdvancedSearchPopover from 'FileManagerCore/components/AdvancedSearchPopover';
import { dismissAdvancedSearchDashboardPopup } from 'FileManagerCore/actions/PortalMeta';
import { getSearchQueryFromUrl } from '../selectors/Query';
import UsageTracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
let trackedSearchLengthLimit = false;
class Search extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      inputValue: this.props.searchQuery
    };
    this.debouncedFetch = debounce(this.props.onFetchSearch, 300);
    this.handleChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        inputValue: value
      });
      this.debouncedFetch(value);
    };
    this.getValidationMessage = value => {
      if (value && value.length > SEARCH_QUERY_WARN_LENGTH) {
        if (!trackedSearchLengthLimit) {
          UsageTracker.track('fileManagerExploreFiles', {
            action: 'search-over-length-limit'
          });
          trackedSearchLengthLimit = true;
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerCore.search.overMaxLength",
          options: {
            maxLength: MAX_SEARCH_QUERY_LENGTH
          }
        });
      }
      return null;
    };
  }
  componentDidUpdate(prevProps) {
    const {
      searchQuery
    } = this.props;
    if (!prevProps.searchQuery && searchQuery) {
      UsageTracker.track('fileManagerExploreFiles', {
        action: 'started-search'
      });
    }
    if (prevProps.searchQuery !== searchQuery && this.state.inputValue !== searchQuery) {
      this.setState({
        inputValue: searchQuery
      });
    }
  }
  render() {
    const {
      hasSeenAdvancedSearchDashboardPopup,
      dismissAdvancedSearchDashboardPopup: dismissAdvancedSearchPopup,
      searchQuery
    } = this.props;
    return /*#__PURE__*/_jsx(AdvancedSearchPopover, {
      hasSeen: hasSeenAdvancedSearchDashboardPopup,
      dismiss: dismissAdvancedSearchPopup,
      trackInteraction: (key, action) => UsageTracker.track(key, {
        action
      }),
      hasQuery: Boolean(searchQuery && searchQuery.length > 0),
      children: /*#__PURE__*/_jsx(UISearchInput, {
        "data-test-id": "search-input",
        className: classnames('search', this.props.className),
        placeholder: this.props.placeholder,
        onChange: this.handleChange,
        value: this.state.inputValue,
        maxLength: MAX_SEARCH_QUERY_LENGTH,
        getValidationMessage: this.getValidationMessage
      })
    });
  }
}
Search.propTypes = {
  onFetchSearch: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  hasSeenAdvancedSearchDashboardPopup: PropTypes.bool,
  dismissAdvancedSearchDashboardPopup: PropTypes.func.isRequired
};
const mapDispatchToProps = {
  dismissAdvancedSearchDashboardPopup
};
const mapStateToProps = (state, props) => ({
  searchQuery: getSearchQueryFromUrl(state, props),
  hasSeenAdvancedSearchDashboardPopup: getHasSeenAdvancedSearchDashboardPopup(state)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));